import { NavLink } from "react-router-dom";
import { ItemTypes } from "./constants";
import { useDrag, useDrop } from "react-dnd";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Makeup(props) {
    const {
        makeup,
        aliasMakeup,
        unaliasMakeup,
        readOnly,
        filmId,
        processingMakeupIds = [],
        isSelected,
        onToggleSelect
    } = props;
    const scriptDaysString = makeup.scriptDays?.join(', ');

    const hasAliases = (makeup.aliases || []).length > 0;
    const isProcessing = processingMakeupIds.includes(makeup.id);

    const makeupDropped = (alias) => {
        if (!isProcessing && !processingMakeupIds.includes(alias.id)) {
            aliasMakeup(filmId, alias, makeup);
        }
    };

    const canDropMakeup = (item, monitor) => {
        return !readOnly && item.makeup.id != makeup.id && !isProcessing && !processingMakeupIds.includes(item.makeup.id);
    };

    const canDragMakeup = (monitor) => {
        return !readOnly && !hasAliases && !isProcessing;
    };

    const [{ isOverMakeup }, dropMakeup] = useDrop({
        accept: ItemTypes.MAKEUP,
        drop: (item: any, monitor) => makeupDropped(item.makeup),
        canDrop: (item, monitor) => canDropMakeup(item, monitor),
        collect: (monitor) => ({
            isOverMakeup: !!monitor.isOver()
        })
    });

    const [{ isDragging }, drag] = useDrag({
        item: { type: ItemTypes.MAKEUP, makeup },
        canDrag: (monitor) => canDragMakeup(monitor),
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging()
        })
    });

    const getItemStyle = (isDragging) => ({
        background: isDragging ? "#947eed" : "#040f21"
    });

    return (
        <>
            <tr ref={drag}
                style={{
                    cursor: !hasAliases && !readOnly && !isProcessing ? "grab" : "not-allowed",
                    opacity: isProcessing ? 0.5 : 1
                }}>
                {!readOnly && (
                    <td>
                        <FilmanizeCheckbox
                            checked={isSelected}
                            onChange={onToggleSelect}
                        />
                    </td>
                )}
                <td ref={dropMakeup} style={getItemStyle(isOverMakeup)}>
                    {!readOnly && !hasAliases && !isProcessing && (
                        <i className="material-icons dark">drag_indicator</i>
                    )}
                    <NavLink to={`/films/${filmId}/makeup/${makeup.id}/edit`}>
                        {makeup.name}
                    </NavLink>
                </td>
                <td>
                    {scriptDaysString}
                </td>
            </tr>
            {(makeup.aliases || []).map((alias) => {
                const aliasIsProcessing = processingMakeupIds.includes(alias.id) || isProcessing;
                return (
                    <tr key={alias.id}
                        style={{ opacity: aliasIsProcessing ? 0.5 : 1 }}>
                        {!readOnly && <td></td>}
                        <td colSpan={4}>
                            <div style={{ marginLeft: 30 }}>
                                {alias.name}
                                &nbsp;
                                {!readOnly && !aliasIsProcessing && (
                                    <a onClick={() => unaliasMakeup(filmId, alias, makeup)}>
                                        <i className="material-icons">cancel</i>
                                    </a>
                                )}
                            </div>
                        </td>
                    </tr>
                );
            })}
        </>
    );
}

export default Makeup;
